import { ContactBar, ContactAvatar } from '@cian/contact-card-component';

import { usePublisher } from '../../hooks';

import { BrandingLevelWrapper } from '../../components/BrandingLevelWrapper';
import { ContactActionsLayout } from '../../components/ContactActionsLayout';
import { SuperAgentLevelViewContainer } from '../SuperAgentLevelViewContainer';
import { AgentBookButtonContainer } from '../AgentBookButtonContainer';
import { AgentPhoneButtonContainer } from '../AgentPhoneButtonContainer';
import { AgentShowMoreOffersContainer } from '../AgentShowMoreOffersContainer';
import { AgentWorkHonestlyProofsContainer } from '../AgentWorkHonestlyProofsContainer';
import { ChatButtonContainer } from '../ChatButtonContainer';

export function PublisherContainer() {
  const { brandingLevel, name, avatar, profileLink, title } = usePublisher();

  return (
    <BrandingLevelWrapper brandingLevel={brandingLevel}>
      <ContactBar
        title={title}
        avatar={<ContactAvatar {...avatar} />}
        name={name}
        href={profileLink}
        target="_blank"
        qualityInfo={<SuperAgentLevelViewContainer />}
        labels={<AgentWorkHonestlyProofsContainer />}
        actions={
          <ContactActionsLayout
            showMoreOffersLink={<AgentShowMoreOffersContainer />}
            chatButton={<ChatButtonContainer />}
            phoneButton={<AgentPhoneButtonContainer />}
            bookButton={<AgentBookButtonContainer />}
          />
        }
      />
    </BrandingLevelWrapper>
  );
}
